module.exports = __webpack_public_path__ + "static/media/home-check.9c8cc10a.svg";